import styled from "styled-components";
import { breakpoints } from "../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div`
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    flex-direction: column;
    row-gap: var(--spacing-2);
    padding: 0 var(--spacing-2);
    background-color: rgba(255, 255, 255, 0.7);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    z-index: var(--z-index-sticky);

    &::before {
        display: block;
        position: absolute;
        bottom: 100%;
        inset-inline: 0;
        width: 100%;
        height: 5.6rem;
        content: "";
        background: linear-gradient(180deg, rgb(255 255 255 / 0) 0%, rgb(255 255 255 / 0.7) 41%);
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        display: none;
    }
`;

export const Body = styled.div`
    display: flex;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    & > button {
        flex: 1 0 100%;
    }
`;

export const SecondaryCtas = styled.div`
    display: flex;
    background-color: var(--color-grey-1);
    border-top: 2px solid var(--color-grey-6);
    border-left: 2px solid var(--color-grey-6);
    border-right: 2px solid var(--color-grey-6);
    border-radius: var(--XS, 0.8rem) var(--XS, 0.8rem) 0rem 0rem;

    ul {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    li {
        margin: 0;
        padding: 0;

        &:not(:nth-last-child(1)) {
            border-bottom: 1px solid var(--color-grey-4);
        }
    }
`;

export const SecondaryCta = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-block: calc(var(--spacing-3) / 2) var(--spacing-1);
    padding-inline: var(--spacing-2);
    color: var(--color-primary-black);

    & > span {
        display: flex;
        column-gap: var(--spacing-1);
    }
`;

export const Badge = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.4rem;
    padding: 0 4px 2px 4px;
    color: var(--color-primary-white);
    background-color: var(--color-highlight-red);
    border-radius: 4px;
`;
